import { cssRule } from 'typestyle';

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-prompt', {
    marginBottom: '12px',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-mode, .tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-hourly, .tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-daily, .tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-details', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-mode', {
    paddingRight: '6px',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-mode-option', {
    margin: '3px',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-right-small-space', {
    marginRight: '6px',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-right-large-space', {
    paddingRight: '70px',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-details-row', {
    paddingBottom: '6px',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-row-caption-cell', {
    display: 'inline-block',
    lineHeight: '23px',
    marginRight: '6px',
    textAlign: 'right',
    verticalAlign: 'top',
    width: '70px',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-row-selector', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-refresh-type', {
    marginTop: '12px',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-refresh-type-prompt', {
    marginTop: '3px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-remote-refresh-custom-schedule-dialog .tb-custom-schedule-editor-refresh-type-option', {
    margin: '3px',
    display: 'block',
});

